import {Injectable} from '@angular/core';
import {RequestOptions, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {AllEventsSetting} from '../models/all-events-setting';
import {EventDetailSetting} from '../models/event-detail-setting';
import {CreatedEventSettings} from '../models/created-event-settings';
import {BackendService} from './backend.service';
import * as moment from 'moment';

@Injectable()
export class EventService {

  constructor(private http: BackendService) {}

  getAllEvents(startDate: string, endDate: string): Observable<EventDetailSetting[]> {
    return new Observable(observer => {
      this.http.get('/api/data/event/getAllEvents/' + startDate + '/' + endDate)
        .subscribe((response) => {
          const data = Object.assign(new AllEventsSetting(), response);
          observer.next(data.data.length ? Object.assign([new EventDetailSetting()], data.data) : []);
          observer.complete();
      }, (error) => {
          observer.error(error);
      });
    });
  }

  postCreateEvent(model: CreatedEventSettings): Observable<any> {
    return Observable.create((subscribe) => {
      this.http.post('/api/data/event/addEvent', JSON.stringify(model))
        .subscribe((response) => {
          const value = Object.assign(new AllEventsSetting(), response);
          subscribe.next(value);
          subscribe.complete();
        }, (error) => {
          subscribe.error(error);
        });
    });
  }

  getDetailEvent(eventId: number): Observable<EventDetailSetting> {
    return Observable.create(subscribe => {
      this.http.get(`/api/data/event/getEventDetail/${eventId}`)
        .subscribe((response) => {
           const value = Object.assign(new AllEventsSetting(), response);
           subscribe.next(Object.assign(new EventDetailSetting(), value.data));
           subscribe.complete();
      }, error => {
        subscribe.error(error);
      });
    });
  }

  putUpdateEvent(eventId: number, model: EventDetailSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/event/updateEvent/${eventId}`, JSON.stringify(model))
        .subscribe((response) => {
          observe.next(response);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  deleteEvent(eventId: number, isDeleteAll): Observable<any> {
    let options, apiUrl;
    options = new RequestOptions({body: {isDeleteAll: isDeleteAll}});
    apiUrl = `/api/data/event/deleteEvent/${eventId}`;
    return Observable.create(observe => {
      this.http.delete(apiUrl, options).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, (error) => {
        observe.error(error);
      });
    });
  }

  checkInEvent(eventId: number): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/event/checkInEvent`, JSON.stringify({eventId: eventId}))
        .subscribe((response) => {
          observe.next(response);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  searchEvents(keyWord: string): Observable<EventDetailSetting[]> {
    return Observable.create(observe => {
      this.http.post(`/api/data/event/searchEvents`, JSON.stringify({key: keyWord})).subscribe((res) => {
        const data = Object.assign(new AllEventsSetting(), res);
        observe.next(data.data.length ? Object.assign([new EventDetailSetting()], data.data) : []);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  getNewEvents(): Observable<any> {
    return Observable.create(observe => {
      this.http.get(`/api/data/event/getRecentEvents`).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  getBookingHistory(searchCondition: any): Observable<any> {
    let params, options;
    // Search Params
    params = new URLSearchParams();
    params.append('date', moment(searchCondition.date, 'MM-YYYY').format('YYYY-MM'));
    params.append('name', searchCondition.name);
    params.append('roomIds', searchCondition.roomIds);
    params.append('status', searchCondition.status);
    options = new RequestOptions({ params: params});
    return Observable.create(subscriber => {
      this.http.get('/api/data/event/getBookingHistory', options).subscribe((res) => {
        subscriber.next(res);
        subscriber.complete();
      }, error => {
        subscriber.error(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/event.service.ts